var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mom-subapp-outlet"})
}
var staticRenderFns = []

export { render, staticRenderFns }